import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import PricingModal from './PricingModal';
import * as ROUTES from '../../../constants/routes';

const TierConProductPricingModal = (props) => {
    const [controlModal, setControlModal] = useState({ toggle: false, priceCard: null });
    const [allConProductModal, setAllConProductModal] = useState({ toggle: false });
    const { tierConProducts, modalStyles, themeColors, modalWidth, modalTitleStyle, modalInfoTextStyle } = props;

    const tierConProductList = tierConProducts ? Object.values(tierConProducts) : [];

    return (
        <React.Fragment>
            {/* BUTTON TO SEE ALL TOPUPS */}
            <button className="btn btn-dark btn-sm" style={{ borderRadius: '8px' }} onClick={() => { setAllConProductModal({ toggle: true }) }}>Increase your limits</button>

            {/* ALL TOPUPS MODAL */}
            <ReactModal
                style={modalStyles}
                isOpen={allConProductModal.toggle}
                onRequestClose={() => { setAllConProductModal({ toggle: false }) }}
                contentLabel="See all top ups"
                ariaHideApp={false}
            >
                <button className="close" onClick={() => { setAllConProductModal({ toggle: false }) }}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <div className="dynamicModalContainer">
                    <div className="dynamicModalSm">
                        <div className="px-3">
                            <p style={modalTitleStyle}>Increase your tag limits with top up plans</p>
                            <p style={modalInfoTextStyle}>The tag top ups below extend the existing tag limits. Note............ Before you buy these top up plans, also consider <Link to={ROUTES.PRICING}>upgrading your subscription</Link> as it might be financially advantageous.</p>
                        </div>
                        <div className="px-3 py-3">
                            {tierConProductList.map((eachPriceCard, i) => {
                                return <button key={i} className="btn btn-outline-dark btn-sm m-1" onClick={() => { setControlModal({ toggle: true, priceCard: eachPriceCard }) }}>{eachPriceCard.itemName}</button>
                            })}
                        </div>
                    </div>
                </div>
            </ReactModal>

            {/* SELECTED TOPUP MODAL */}
            <ReactModal
                style={modalStyles}
                isOpen={controlModal.toggle}
                onRequestClose={() => { setControlModal({ toggle: false }) }}
                contentLabel="Select a topup"
                ariaHideApp={false}
            >
                <button className="close" onClick={() => { setControlModal({ toggle: false }) }}>
                    <span aria-hidden="true">&times;</span>
                </button>
                {controlModal.priceCard ? <PricingModal priceCard={controlModal.priceCard} isTopup={true} /> : <p>Select a topup product</p>}
            </ReactModal>
        </React.Fragment>
    );
};


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        isSignedIn: !state.firebase.auth.isEmpty,

        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        productOrder: state.firestore.data.ProductOrder,
        tierConProducts: state.firestore.data.TierConProducts,
    }
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect((props) => {
        const { productOrder } = props;
        const { productId } = productOrder;
        // let tierId = props.tierId ?? "tier_test";
        return [
            {
                collection: "ConStore",
                where: [['belongsToPlan', '==', productId]],
                storeAs: "TierConProducts",
            },
        ]
    })
)(TierConProductPricingModal);